import script from "./GmxLinkedLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./GmxLinkedLabel.vue?vue&type=script&setup=true&lang=js"

import "./GmxLinkedLabel.vue?vue&type=style&index=0&id=e5dfacbe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5dfacbe"]])

export default __exports__